module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="photoInputForm">\n    <div>\n        <label class="photoInputFormLabel photoInputFormLabelPosition" for="photoFormFile">Choisir des photos</label>\n        <input class="photoInputFormInput specialFileMask formInput" type="text" placeholder="Parcourir..." aria-label="Fichiers sélectionnés" disabled>\n        <input class="photoInputFormInput photoInputFormFile formInput" type="file" id="photoFormFile" name="file" multiple>\n    </div>\n    <div class="pendingFilesHolder">\n    </div>\n</div>\n';

}
return __p
}